import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  goalSubmitted(data: Data & { useCase: string; useCaseDetail: string; signupType: string }) {
    return {
      Goal: data.useCase.replace(/_/g, ' '),
      Comments: data.useCaseDetail,
      'Signup Type': data.signupType,
    };
  },

  referralSourceSubmitted(data: Data & { referrer: string; comments: string; signupType: string }) {
    return {
      Referrer: data.referrer,
      Comments: data.comments,
      'Signup Type': data.signupType,
    };
  },

  signupType(
    data: Data & {
      signupType: string;
      fakeDoorExperiment?: boolean;
      campaignTemplateGalleryExperiment?: boolean;
      testDeliveryMode?: boolean;
    },
  ) {
    return {
      'Signup Type': data.signupType,
      'Fake Door Experiment': data.fakeDoorExperiment,
      'Campaign Template Gallery Experiment': data.campaignTemplateGalleryExperiment,
      'Test Delivery Mode': data.testDeliveryMode,
    };
  },
  roleSubmitted(data: Data & { role: string; roleOther: string; signupType: string }) {
    return {
      Role: data.role,
      Comments: data.roleOther,
      'Signup Type': data.signupType,
    };
  },
  channelsSubmitted(data: Data & { channel: string; channelsOther: string; signupType: string }) {
    return {
      Channel: data.channel,
      Comments: data.channelsOther,
      'Signup Type': data.signupType,
    };
  },
  toolExperienceSubmitted(data: Data & { automationExperience: string; signupType: string }) {
    return {
      'Automation Experience': data.automationExperience,
      'Signup Type': data.signupType,
    };
  },
  connectingDataSubmitted(data: Data & { integrationExperience: string; signupType: string }) {
    return {
      'Integration Experience': data.integrationExperience,
      'Signup Type': data.signupType,
    };
  },
};

export default Transforms;
